/** Matches Leaflet default marker proportions (see `leaflet/dist/images/marker-icon.png`). */
export const PIN_ICON_WIDTH = 25
export const PIN_ICON_HEIGHT = 41

const DEFAULT_PIN = '#3b82f6'

/** Safe `fill` / Mapbox `color` string (hex or short CSS color name). */
export function safePinColor(color: string | undefined): string {
  const c = (color ?? DEFAULT_PIN).trim()
  if (/^#[0-9A-Fa-f]{3,8}$/.test(c)) return c
  if (/^[a-zA-Z][a-zA-Z0-9-]*$/.test(c) && c.length <= 32) return c
  return DEFAULT_PIN
}

/**
 * Raster-free pin for Leaflet `L.icon` — fill uses `safePinColor(color)`.
 */
export function pinIconDataUrl(color: string | undefined): string {
  const fill = safePinColor(color)
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 41" width="${PIN_ICON_WIDTH}" height="${PIN_ICON_HEIGHT}"><path fill="${fill}" d="M12.5 0C5.6 0 0 5.5 0 12.3 0 21 12.5 41 12.5 41S25 21 25 12.3C25 5.5 19.4 0 12.5 0z"/><circle cx="12.5" cy="12.5" r="4" fill="#fff"/></svg>`
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
